import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MultiSelect as MultiSelectComponent } from 'react-native-element-dropdown';

// Omit props from the inferred MultiSelect props that are handled manually by SelectProps
type CustomMultiSelectProps = Omit<
  React.ComponentProps<typeof MultiSelectComponent>,
  'data' | 'value' | 'onChange' | 'labelField' | 'valueField' | 'style'
>;

interface MultiSelectProps extends CustomMultiSelectProps {
  label: string;
  options: any[];
  value: string[];
  onChange: (value: string[]) => void;
  labelField?: string;
  valueField?: string;
  customStyle?: {
    container?: any;
    label?: any;
    input?: any;
  };
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  label,
  options,
  value,
  onChange,
  labelField = 'label',
  valueField = 'value',
  customStyle = {},
  ...rest
}) => {
  return (
    <View style={customStyle.container}>
      {label && <Text style={customStyle.label}>{label}</Text>}
      <MultiSelectComponent
        style={[styles.dropdown, customStyle.input]}
        data={options}
        labelField={labelField}
        valueField={valueField}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  dropdown: {
    borderWidth: 1,
    borderColor: '#808080',
    borderRadius: 0,
    padding: 8,
    minHeight: 40,
  },
});

export default MultiSelect;